import Premise from "../../slices/premises/premise/Premise";
import ManagePremiseList from "../../slices/premises/premise/ManagePremiseList";
import Zone from "../../slices/premises/zone/Zone";
import Level from "../../slices/premises/level/Level";
import Unit from "../../slices/premises/unit/Unit";
import UserWiseUnit from "../../slices/premises/unit/UserWiseUnit";
import HierarchyList from "../../slices/premises/premise/HierarchyList";
import AssignUnit from "../../slices/premises/assign_unit/AssignUnit";
import VacateUnit from "../../slices/premises/vacate_unit/VacateUnit";
import Gate from "../../slices/premises/gate/Gate";
import Parking from "../../slices/premises/parking/Parking";
import Vehicle from "../../slices/premises/vehicle/Vehicle";
import Residents from "../../slices/premises/residents/Residents";
import Rule from "../../slices/premises/rules/Rule";
import Vendor from "../../slices/premises/vendor/Vendor";
import PremiseAssignment from "../../slices/premises/premise_assignment/PremiseAssignment";

const premisesReducer = {
    premise: Premise,
    managePremiseList: ManagePremiseList,
    zone: Zone,
    level: Level,
    unit: Unit,
    userWiseUnit: UserWiseUnit,
    hierarchyList: HierarchyList,
    assignUnit: AssignUnit,
    vacateUnit: VacateUnit,
    gate: Gate,
    parking: Parking,
    vehicle: Vehicle,
    residents: Residents,
    rule: Rule,
    vendor: Vendor,
    premiseAssignment: PremiseAssignment,
};

export default premisesReducer;